
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packs/[slug]",
      function () {
        return require("private-next-pages/packs/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packs/[slug]"])
      });
    }
  